(function () {
  'use strict';

  angular.module('app').service('ClientTypeModalService', ClientTypeModalService);

  ClientTypeModalService.$inject = ['ModalService'];

  function ClientTypeModalService(ModalService) {
    var service = {
      openClientTypes: openClientTypes,
    };

    return service;

    ////////////////

    function openClientTypes(getItemsCallback) {
      ModalService.showModal({
        templateUrl: './app/ajs/client-types/modals/client-type-list-modal.html',
        controller: ClientTypeListModalCtrl,
        controllerAs: 'vm',
      }).then(function (modal) {
        modal.element.modal();

        modal.element.on('hidden.bs.modal', function () {
          getItemsCallback();
        });
      });

      ClientTypeListModalCtrl.$inject = [
        'ClientTypeService',
        'LanguageService',
        'AbilityService',
        'UtilService',
      ];
    }

    function ClientTypeListModalCtrl(
      ClientTypeService,
      LanguageService,
      AbilityService,
      UtilService
    ) {
      var vm = this;

      vm.UtilService = new UtilService(vm);

      vm.permissions = {
        canList: AbilityService.can('index_clienttype_accountadmin'),
        canCreate: AbilityService.can('create_clienttype_accountadmin'),
      };

      // Methods
      vm.addItem = addItem;
      vm.onSavedItem = onSavedItem;
      vm.cancel = cancel;
      vm.onCanceledItem = onCanceledItem;
      vm.onShowItem = onShowItem;
      // vm.onDeletedItem  = onDeletedItem;

      // Initializers
      // getItems();
      getAdditionalLanguages();

      // TODO: @willy - how are we going to deal with translations
      // 1- No translation / Per user language / Per content language

      function getAdditionalLanguages() {
        LanguageService.getLanguages({ skip_check_role: true }).then(function (data) {
          let languages = data.items;

          vm.defaultLanguage = languages.filter((language) => language.is_default)[0].lang;
          vm.additionalLanguages = languages.filter((language) => !language.is_default);

          getItems('');
        });
      }

      function getItems(selectedItem) {
        vm.filterCriteria = ClientTypeService.getFilterCriteria();
        vm.filterCriteria.lang = vm.defaultLanguage;

        vm.loadingItems = true;
        ClientTypeService.getClientTypes(vm.filterCriteria).then(function (data) {
          vm.items = data.items;
          vm.meta = data.meta;

          if (selectedItem) {
            vm.UtilService.itemListChanged(selectedItem.id);
          }

          vm.loadingItems = false;
        });

        vm.modalTitle = 'CLIENT_TYPES';
      }

      function getItem(item) {
        vm.item = null;

        vm.loadingItem = true;
        ClientTypeService.getClientType(item.id, vm.defaultLanguage).then(function (data) {
          vm.item = data;

          vm.loadingItem = false;
        });
      }

      function addItem() {
        vm.createMode = true;
        vm.item = {};
        vm.modalTitle = 'NEW_CLIENT_TYPE';
      }

      function onSavedItem(item) {
        //vm.UtilService._clearFlashMessage();
        //getItem(item);
        cancel(item);
      }

      function cancel(item) {
        vm.createMode = false;
        vm.editMode = false;

        getItems(item);
      }

      function onCanceledItem() {
        cancel('');
      }

      function onShowItem(item, mode) {
        vm.editMode = true;
        vm.modalTitle = 'CLIENT_TYPE_DETAILS';

        vm.mode = mode;

        getItem(item);
      }

      // function onDeletedItem() {
      //     cancel();
      // }
    }
  }
})();
